import { useWatch } from '@graphcommerce/ecommerce-ui'
import { Money } from '@graphcommerce/magento-store'
import { useFormAddProductsToCart } from '../AddProductsToCart'
import { ProductPagePriceFragment } from './ProductPagePrice.gql'
import { getProductTierPrice } from './getProductTierPrice'
import { Stack, Typography } from '@mui/material'

type ProductPagePriceProps = { product: ProductPagePriceFragment; index?: number }

export function ProductPagePrice(props: ProductPagePriceProps) {
  const { product, index = 0 } = props

  const { control } = useFormAddProductsToCart()
  const quantity = useWatch({ control, name: `cartItems.${index}.quantity` })
  const price =
    getProductTierPrice(product, quantity) ?? product.price_range.minimum_price.final_price

  const getRegularPrice = (product:ProductPagePriceFragment) => {
    if(!product?.price_range?.minimum_price?.regular_price) return null
    const { regular_price: regularPrice } =  product.price_range.minimum_price
    const {  final_price: finalPrice } = product.price_range.minimum_price
    if(regularPrice?.value === finalPrice?.value) return null

    return regularPrice
    
  }

  return <Stack direction="row" alignItems="flex-start" spacing={2}>
    <Typography fontSize="sm" pr="2" variant='h6' className='ProductListPrice-discountPrice'>
  {getRegularPrice(product) && <Money {...getRegularPrice(product)} />}
  </Typography>
  <Typography fontSize="md" pr="2" variant='h4'>

  <Money {...price} />
  </Typography>
  </Stack>
}
